import { render, staticRenderFns } from "./MultipleChoiceInputStandard.vue?vue&type=template&id=50fad01e&scoped=true&"
import script from "./MultipleChoiceInputStandard.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceInputStandard.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceInputStandard.vue?vue&type=style&index=0&id=50fad01e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fad01e",
  null
  
)

export default component.exports